import 'babel-polyfill'

import VueApollo from 'vue-apollo'

import cmsBootstraps from '@wittignl/js-cms/bootstrap'

import ComponentBootstrap from 'app/bootstrap/ComponentBootstrap'
import PluginBootstrap from 'app/bootstrap/PluginBootstrap'
import ApolloBootstrap from 'app/bootstrap/ApolloBootstrap'
import RouterBootstrap from 'app/bootstrap/RouterBootstrap'
import ServiceBootstrap from 'app/bootstrap/ServiceBootstrap'
import FilterBootstrap from 'app/bootstrap/FilterBootstrap'
import ProjectionBootstrap from 'app/bootstrap/ProjectionBootstrap'

import di from 'di'

import App from 'app/components/App.vue'
import RelayAccountType from 'app/auth/RelayAccountType'


// Bootstrap
const bootstrap = [

    ...cmsBootstraps,

    new ServiceBootstrap,
    new RouterBootstrap,
    new PluginBootstrap,
    new ApolloBootstrap,
    new ComponentBootstrap,
    new FilterBootstrap,
    new ProjectionBootstrap
];

bootstrap.forEach(strap => strap.run());

// Run
const router = di.get('router');
const i18n = di.get('i18n');
const logger = di.get('logger').child('Main');

const apolloProvider = new VueApollo({
    defaultClient: di.get('apollo'),
});


const run = () => {

    new App({
        'el': '#app-wrapper',
        router,
        apolloProvider,
        i18n,
        breadcrumb: true,
        modal: true
    });

    document.getElementsByClassName('full-screen-loader')[0].classList.remove('cloak');
};

// Check relay token
RelayAccountType.loginIfNeeded().then((session) => {

    if(session) {
        logger.info('Relay login successful');
    }
    else {
        logger.info('Relay login failed');
    }

    run();

}).catch(e => {

    logger.error('Error logging in via relay', e);

    const config = di.get('config')
    document.location.href = config.mijnAvecoUrl + "account?access=denied";
});
